import React, {useEffect} from 'react';
import {useSelector} from 'react-redux';

import defaultImage from '../../../../assets/images/manual-registration/manual-registration-image.jpg';
import {DualLayout} from '../../../components/DataDisplay';
import {ErrorIcon} from '../../../components/Icons';
import PopupFullPage from '../../../components/Popup/PopupFullPage';
import appConfig from '../../../config/appConfig';
import useDocumentTitle from '../../../hooks/useDocumentTitle';
import useSuccessNotificationsRemover from '../../../hooks/useSuccessNotificationsRemover';
import {amplitudeRegistrationTracking} from '../../../services/amplitude';
import analyticsService from '../../../services/analyticsService';
import deviceTypesService from '../../../services/device/deviceTypesService';
import {makeSelectIotDeviceMergedWithConsumerProduct} from '../../../state/selectors/consumer';
import elementsTesIds from '../../../test/consts/elementsTesIds';
import SignedImage from '../../System/SignedImage';
import ManualRegistrationForm from './ManualRegistrationForm';
import {getRegistrationManualPageContent} from './registrationManualService';

const ManualRegistrationPopup = (props) => {
    const {
        isAutoRegistrationFailed,
        isManualRegistrationFailed,
        manualRegistrationError,
        codentifyWithError,
        modalType,
        isHolder,
    } = props;

    const isRegistrationFailed = isAutoRegistrationFailed || isManualRegistrationFailed;
    const {device} = useSelector(makeSelectIotDeviceMergedWithConsumerProduct());
    const {type: deviceType, name: productName = ''} = device || {};
    const devicePlatform = deviceTypesService.getDevicePlatform(deviceType);
    const imagePath = appConfig.getManualRegistrationImagePath(devicePlatform);
    const pageContent = getRegistrationManualPageContent(productName, isRegistrationFailed);
    const {title, description, imageDescription, documentTitle} = pageContent;

    useDocumentTitle(documentTitle);

    useEffect(() => {
        if (manualRegistrationError) {
            analyticsService.pushManualRegistrationEvent(deviceType);
            amplitudeRegistrationTracking.trackRegistrationGamError(isHolder);
        }
    }, [manualRegistrationError]);

    useEffect(() => {
        analyticsService.pushManualRegistrationFlowEvent(deviceType);
    }, []);

    useSuccessNotificationsRemover(!!isRegistrationFailed);

    return (
        <PopupFullPage contentLabel={title} data-testid={elementsTesIds.PAIRING_SEQUENCE_SKIP_PAGE}>
            <DualLayout
                className='pb-8 lg:py-36'
                classNameRight='flex flex-col items-start justify-center'
                articleProps={{
                    icon: isRegistrationFailed && <ErrorIcon className='-mb-1 mt-6 lg:hidden' />,
                    titleText: title,
                    titleClassName: 'mt-8 mb-3 lg:mt-0 lg:mb-6 lg:text-42',
                    className: 'lg:items-start',
                    descriptionText: description,
                    children: (
                        <ManualRegistrationForm
                            manualRegistrationError={manualRegistrationError}
                            pageContent={pageContent}
                            productName={productName}
                            modalType={modalType}
                            codentifyWithError={codentifyWithError}
                            isHolder={isHolder}
                        />
                    ),
                }}
            >
                <SignedImage
                    imgClassName='h-[212px] w-full object-cover object-cover bg-center md:h-[420px] lg:h-[540px]'
                    defaultImage={defaultImage}
                    isThumbnailAvailable
                    mediaData={imagePath}
                    signIfNull
                />
                <p className='mt-7 hidden lg:mt-6 lg:block'>{imageDescription}</p>
            </DualLayout>
        </PopupFullPage>
    );
};

export default ManualRegistrationPopup;
